<template>
    <div class="withYlands-wrapper">
        <div class="withYlands-main">
            <div class="withYlands-main__title"><b>Create</b> with Ylands</div>

            <div class="withYlands-main__description">
                <p>
                    Everything is possible if you mix Ylands <br />and your
                    Creativity
                </p>
            </div>
            <div class="withYlands-main-home-play">
                <ImageOptimized
                    :file-name="'/home/top/ylands_comp_create_top'"
                    :alt="'ylands create composition top '"
                    :sizes="['600', '1000', '1920']"
                    :load="'eager'"
                />
            </div>
            <div class="withYlands-main__descriptionTwo">
                <p>
                    Enter a world supported and sustained by your
                    <span class="withYlands-main__yellow-word">creativity</span>
                </p>
            </div>
            <div class="withYlands-main-buttons">
                <default-button
                    class="withYlands-main-buttons--button"
                    :component-nav="true"
                    :color="'orange'"
                    :outside="true"
                    :text="'LOG IN'"
                    :link="'/api/v1.0/auth/'"
                    :width-static="'230px'"
                />

                <default-button
                    class="withYlands-main-buttons--button"
                    :color="'transparent'"
                    :text="'LEARN MORE'"
                    :target="'.tools-main'"
                    :same-page="true"
                    :width-static="'230px'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/common/Button';
import ImageOptimized from '@/components/common/ImageScaler';

export default {
    name: 'WithYlands',
    components: {
        'default-button': Button,
        ImageOptimized,
    },
};
</script>

<style scoped lang="scss">
.withYlands-wrapper {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: url('~Images/home/backgr-home-first-section.png') no-repeat
        center center;
    background-size: cover;
    position: relative;
    z-index: 1;

    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 94%);
    @media (max-width: $xm-up) {
        background: url('~Images/home/backgr-home-first-section_1000.png')
            no-repeat center center;
    }
    @media (max-width: $xs-up) {
        background: url('~Images/home/backgr-home-first-section_510.png')
            no-repeat center center;
    }
}
.withYlands-main {
    margin: 150px 25px;
    &__title {
        color: $white-main;
        font-family: $politica-font;
        font-size: 55px;
        font-weight: 700;
        letter-spacing: 2.5px;
        line-height: 60px;
        margin: auto;
        text-align: center;

        @media (max-width: $xs-up) {
            font-size: 35px;
            letter-spacing: 1.59px;
            line-height: 40px;
        }
    }

    &__description {
        text-align: center;
        color: $white-main;
        font-family: $politica-font;
        font-size: 34px;
        letter-spacing: 1.3px;
        line-height: 45px;

        p {
            margin-bottom: 0;
        }

        @media (max-width: $xs-up) {
            font-size: 22px;
            letter-spacing: 0.41px;
            line-height: 24px;
        }
    }

    &-home-play {
        max-width: 1920px;
        width: 100%;
        height: auto;
        margin: 0 auto;
    }

    &__descriptionTwo {
        text-align: center;
        color: $white-main;
        font-family: $politica-font;
        letter-spacing: 1.3px;
        font-size: 28px;
        font-weight: 700;
        line-height: 42px;

        @media (max-width: $xs-up) {
            font-size: 16px;
            letter-spacing: 0.5px;
            line-height: 24px;
        }
    }

    &__yellow-word {
        color: $yellow-main;
        font-weight: 700;
    }

    .withYlands-main-buttons {
        display: flex;
        width: 100%;
        justify-content: center;

        @media (max-width: $sm-up) {
            flex-direction: column;
            align-items: center;
        }

        &--button {
            text-transform: uppercase;
            &:not(:first-child) {
                margin-left: 30px;
            }
            @media (max-width: $sm-up) {
                &:not(:first-child) {
                    margin-left: 0px;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>
